import { MarkerDisplayLevels1, MarkerDisplaySize } from 'types/location.js';
import { predicateObject, predicatePopulatedString } from 'utilities/isType.js';
import { MARKER_ZOOM_DEFAULT } from './zoom-utils.js';
import { MarkerDisplayLevels2 } from './zoom-v2.js';
import { MarkerDisplayLevels3 } from './zoom-v3.js';

/** Converts Display Levels v1 into Display Levels v2 */
export const convertL1MarkerZoomToL2 = (
  levels?: Partial<MarkerDisplayLevels1> | MarkerDisplayLevels2,
): MarkerDisplayLevels2 => {
  if (predicateObject(levels)) {
    const keys = Object.keys(levels);
    const displayLevels1Keys = keys.filter((key) =>
      Object.values(MarkerDisplaySize).includes(key as MarkerDisplaySize),
    );
    if (displayLevels1Keys.length) {
      /** This is a Levels1 item */
      const levelsObj = levels as Partial<MarkerDisplayLevels1>;
      const levelKeys = displayLevels1Keys as Array<keyof Partial<MarkerDisplayLevels1>>;

      const v2 = levelKeys.reduce<NonNullable<MarkerDisplayLevels2>>((acc, key) => {
        const value = key as keyof MarkerDisplayLevels1;
        const size = levelsObj[value];
        if (size) {
          acc[size] = value;
        }
        return acc;
      }, {});

      v2['default'] = MarkerDisplaySize.Small;
      return v2;
    }
    return levels as MarkerDisplayLevels2;
  }
  return MARKER_ZOOM_DEFAULT;
};

/** Converts Display Levels v3 into Display Levels v2 */
export const convertL3MarkerZoomToL2 = (levels?: MarkerDisplayLevels2 | MarkerDisplayLevels3): MarkerDisplayLevels2 => {
  if (predicatePopulatedString(levels)) {
    const [small, medium, large] = levels.split('-').map(Number);
    if ([small, medium, large].includes(0)) {
      const zoomObj: Record<MarkerDisplaySize, number> = { small, medium, large };

      const cleanedZoomObj = Object.keys(zoomObj).reduce<MarkerDisplayLevels2>((acc, _key) => {
        const key = _key as MarkerDisplaySize;
        const value = zoomObj[key];
        if (!isNaN(value)) {
          if (value !== 0) {
            acc[value] = key;
          }
          if (value === 0) {
            acc['default'] = key;
          }
        }
        return acc;
      }, {});

      return cleanedZoomObj;
    }
  }
  if (predicateObject(levels)) {
    return levels;
  }
  return MARKER_ZOOM_DEFAULT;
};
